import { Component, ComponentFactoryResolver, ElementRef } from '@angular/core';
import { AnimationService } from '../../animation.service';
import { StateSelectComponent } from '../state-select/state-select.component';
import { ToolbarComponent } from '../toolbar/toolbar.component';

// declare function require(name: string);

@Component({
    selector: 'app-animation-toolbar',
    templateUrl: '../toolbar/toolbar.component.html',
    styleUrls: ['../toolbar/toolbar.component.scss'],
    standalone: false
})
export class AnimationToolbarComponent extends ToolbarComponent {
  private _animationService: AnimationService;

  public constructor(
    elementRef: ElementRef,
    componentFactoryResolver: ComponentFactoryResolver,
    animationService: AnimationService
  ) {
    super(elementRef);
    this._animationService = animationService;

    this.items = [
      {
        imageUrl: 'assets/first_frame.svg',
        tooltip: 'Skip to first frame',
        execute: () => this._animationService.skipFirst(),
      },
      {
        imageUrl: 'assets/step_bwd.svg',
        tooltip: 'Step backwards',
        execute: () => this._animationService.skipPrevious(),
      },
      {
        imageUrl: 'assets/play_fwd.svg',
        tooltip: 'Play',
        getHidden: () => this._animationService.isAnimationTaskAlive,
        execute: () => this._animationService.play(true),
      },
      {
        imageUrl: 'assets/stop.svg',
        tooltip: 'Stop',
        getHidden: () => !this._animationService.isAnimationTaskAlive,
        execute: () => this._animationService.stop(),
      },
      {
        imageUrl: 'assets/step_fwd.svg',
        tooltip: 'Step forwards',
        execute: () => this._animationService.skipNext(),
      },
      {
        imageUrl: 'assets/last_frame.svg',
        tooltip: 'Skip to last frame',
        execute: () => this._animationService.skipLast(0),
      },
      // {
      //     imageUrl: require("assets/images/animation/slower.svg"),
      //     tooltip: "Decrease speed",
      //     execute: () => this._animationService.slower(),
      // },
      // {
      //     imageUrl: require("assets/images/animation/faster.svg"),
      //     tooltip: "Increase speed",
      //     execute: () => this._animationService.faster(),
      // },
    ];

    this.extraComponentFactory = componentFactoryResolver.resolveComponentFactory(StateSelectComponent);
  }
}
